module.exports = __webpack_public_path__ + "img/xu.b1154f0f.png";